import { useSelector } from "react-redux";
import styled, { css } from "styled-components";
import { RootState } from "../store";

//region style
const Container = styled.div`
  width: 100%;

  ${(props) => {

    if (props.theme.isMobile || props.theme.isTablet) {
      return css`
        margin-top:20px;
      `;
    }

  }}

`;

const Provider = styled.p`
  color: #5d5d5d;
  font-weight: bold;
  margin-block-start: 0;
  margin-block-end: 0;
  line-height:30px;
  text-align:right;
  ${(props) => {

    if (props.theme.isMobile || props.theme.isTablet) {
      return css`
        font-size: 18px;
      `;
    }
    else {
      return css`
        font-size: 22px;
      `;
    }
  }}
`;

const Link = styled.a`
  color: #9cc064;
  background-color: transparent;
  text-decoration: none;
  padding-right: 15px;
`;

//endregion

function DSI(props: any) {
  const isMobile: any = useSelector((state: RootState) => state.storeSlice.isMobile);
  const isTablet: any = useSelector((state: RootState) => state.storeSlice.isTablet);

  const UpdateYear = 2026;
  const UpdateMonth = 2;

  if (isMobile || isTablet) {
    return (
      <Container>
        <Provider>
          資料來源：<Link target={'_blank'} title="身份證明局 DSI" href="https://www.dsi.gov.mo/" rel="noreferrer">身份證明局</Link>
          <br/>
          註：數據為1990年以來的累計數字
          <br/>
          （更新於{UpdateYear}年{UpdateMonth}月）
        </Provider>
      </Container>
    )
  }
  else{
    return (
      <Container>
        <Provider>
          資料來源：<Link target={'_blank'} title="身份證明局 DSI" href="https://www.dsi.gov.mo/" rel="noreferrer">身份證明局</Link>
          <br/>
          註：數據為1990年以來的累計數字（更新於{UpdateYear}年{UpdateMonth}月）
        </Provider>
      </Container>
    )
  }

}

export default DSI;
